import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, Paper } from '@mui/material';
import { Title } from '../types';

const dummyRequests: Title[] = [
    {
        id: 1,
        external_id: "tt1234567",
        title_name: "Stranger Things",
        release_year: 2016,
        poster_url: "https://via.placeholder.com/150",
        overview: "A group of kids encounter supernatural forces in their small town.",
    },
    {
        id: 2,
        external_id: "tt2345678",
        title_name: "The Mandalorian",
        release_year: 2019,
        poster_url: "https://via.placeholder.com/150",
        overview: "A lone bounty hunter travels the outer reaches of the galaxy.",
    },
];

export const Profile: React.FC = () => {
    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                Your Profile
            </Typography>

            <Paper sx={{ p: 3, mb: 3 }}>
                <Typography variant="h6" gutterBottom>
                    Your Requests
                </Typography>
                <List>
                    {dummyRequests.map((title) => (
                        <ListItem key={title.id}>
                            <ListItemText
                                primary={`${title.title_name} (${title.release_year})`}
                                secondary={`Requested on ${new Date().toLocaleDateString()}`}
                            />
                        </ListItem>
                    ))}
                </List>
            </Paper>

            <Paper sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom>
                    Your Upvotes
                </Typography>
                <List>
                    {dummyRequests.map((title) => (
                        <ListItem key={title.id}>
                            <ListItemText
                                primary={`${title.title_name} (${title.release_year})`}
                                secondary={`Upvoted on ${new Date().toLocaleDateString()}`}
                            />
                        </ListItem>
                    ))}
                </List>
            </Paper>
        </Box>
    );
};